import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import TeamContent from "../ones/TeamContent";
import CallToAction from "../ones/CallToAction";

export default function TeamLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <TeamContent />
        <CallToAction />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
